import { public_urls, mainAppURL } from '../../config';
import { CREATE_CONFIGURATION_PLATFORMS } from '../../constants/configurations';
import { createConfiguration } from '../../services/configuration.service';

export const CREATE_CONFIGURATION = 'CREATE_CONFIGURATION';
export const CREATE_CONFIGURATION_FINISH = 'CREATE_CONFIGURATION_FINISH';
export const REDIRECT_CONFIGURATION = 'REDIRECT_CONFIGURATION';

export const UPDATE_NEW_CONFIGURATION = 'UPDATE_NEW_CONFIGURATION';

export const UPDATE_ERRORS = 'UPDATE_ERRORS';

export function createConfigurationAndOpen() {
  return async (dispatch, getState) => {
    const currentState = getState().newConfiguration;
    const newConfigurationData = currentState.newConfigurationData;
    const countryState = getState().country;
    const countries = countryState.countries;

    const selectedCountry = countries.find(country => country.countryCode3 === newConfigurationData.countryCode3) || {};
    localStorage.setItem('country', JSON.stringify(selectedCountry));

    const configData = {
      ...newConfigurationData,
      configurationName: newConfigurationData.configurationName.trim(),
      customerName: newConfigurationData.customerName.trim(),
      passedSteps: { platform: true, opportunity: true, details: true },
    };

    dispatch({
      type: CREATE_CONFIGURATION,
    });

    try {
      const { taskId } = await createConfiguration({ configData });

      const platform = CREATE_CONFIGURATION_PLATFORMS.find(({ value }) => value === configData.platform);
      const angularAppPrefix = '/v1';

      dispatch({
        type: REDIRECT_CONFIGURATION,
      });
      window.location.href = `${mainAppURL}${angularAppPrefix}/#/${platform.redirect}/${taskId}/configure-deployment`;
    } catch (err) {
      console.log(err);
      window.location.href = `/#${public_urls.createConfigurationError}`;
    } finally {
      dispatch({
        type: CREATE_CONFIGURATION_FINISH,
      });
    }
  };
}

export function updateNewConfiguration(update) {
  return (dispatch, getState) => {
    const currentState = getState().newConfiguration;
    dispatch({
      type: UPDATE_NEW_CONFIGURATION,
      newConfigurationData: { ...currentState.newConfigurationData, ...update },
    });
  };
}

export function updateNewConfigurationErrors(errors) {
  return async dispatch => {
    dispatch({
      type: UPDATE_ERRORS,
      errors,
    });
  };
}
